import CopyAll from '@mui/icons-material/CopyAll'
import { Button, IconButton } from '@mui/material'
import { copyToClipBoard } from 'src/consumer/helpers/utilFunctions'

export default function CopyButton({
  label,
  value,
  className = 'flex-shrink-0',
  buttonLabel,
  buttonSize,
}) {
  const handleCopy = (event) => {
    event.stopPropagation()
    copyToClipBoard(label, value)
  }
  if (buttonLabel) {
    return (
      <Button className={className} startIcon={<CopyAll />} onClick={handleCopy} size={buttonSize}>
        {buttonLabel}
      </Button>
    )
  }

  return (
    <IconButton className={className} onClick={handleCopy} size={buttonSize}>
      <CopyAll />
    </IconButton>
  )
}
